import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { withRouter } from '@piconetworks/router-adapter'

import Wizard from 'common/modules/wizard'

import OfferOptions from './OfferOptions'

const InjectedOfferOptions = ({ router }) => {
    const productOptionId = useSelector(
        (state) => Wizard.selectors.thisWizardProductOptionId({
            state,
            router,
        }),
    )

    return (
        <OfferOptions
            productOptionId={productOptionId}
        />
    )
}

InjectedOfferOptions.propTypes = {
    router: PropTypes.any.isRequired,
}

export default withRouter(InjectedOfferOptions)
